<template>
  <v-app>
    <v-container>
      <PitchEnglishHomeApplicationTemplate>
        <router-view />
        <!-- Card 86akqxu0h: aviso de formulario pendente ao entrar. -->
        <pending-surveys-prompt profile="customer" />
      </PitchEnglishHomeApplicationTemplate>
    </v-container>
  </v-app>
</template>
<script>
import PitchEnglishHomeApplicationTemplate from "@/template/ApplicationTemplate";
import PendingSurveysPrompt from "@/components/surveys/PendingSurveysPrompt.vue";
export default {
  components: {
    PitchEnglishHomeApplicationTemplate,
    PendingSurveysPrompt,
  },
};
</script>
